// 店铺角色的菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/shopIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-goods',
    index: '/goodsList',
    title: '商品管理',

  },
  {
    icon: 'el-icon-s-order',
    index: '3',
    title: '订单管理',
    subs: [
      {
        index: '/orderList',
        title: '订单管理',
      },
      {
        index: '/settlementOrderList',
        title: '结算列表',
      },
    ]
  },
  {
    icon: 'el-icon-s-order',
    index: '/shopManage',
    title: '店铺管理',
  },
  {
    icon: 'el-icon-s-order',
    index: '/shopWealthRecordListForShop',
    title: '店铺流水',
  },
  {
    icon: 'el-icon-s-order',
    index: '/shopAddressList',
    title: '店铺收货地址',
  },

]

export default menus
